<template>
  <asc-dialog
    :show-dialog="showDialog"
    :text="getDialogTitle"
    :on-close="handleClose"
    :width="1000"
  >
    <template v-if="showDialog">
      <asc-open-maintenance
        :items="items"
        :tail-number="tailNumber"
        :grid-columns="gridColumns"
        :on-open-full-fleet="handleOpenFullFleet"
        :loading="loading"
      ></asc-open-maintenance>
    </template>
  </asc-dialog>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import { AscDialogMixin } from '@/components/mixins'
import AscOpenMaintenance from './AscOpenMaintenance'

export default {
  name: 'AscOpenMaintenanceDialog',

  components: {
    AscDialog,
    AscOpenMaintenance,
  },

  mixins: [AscDialogMixin],

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    tailNumber: {
      type: String,
      default: '',
    },
    gridColumns: {
      type: Array,
      default: () => [],
    },
    onOpenFullFleet: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    getDialogTitle() {
      return `Open Maintenance for ${this.tailNumber}`
    },
  },

  methods: {
    handleOpenFullFleet() {
      this.onClose()
      if (this.onOpenFullFleet) {
        this.onOpenFullFleet()
      }
    },
  },
}
</script>
